/**
 * @generated SignedSource<<9416ceba40cd57dc771758735163782f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 8,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "includeIsAuthorized"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "media",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "removed",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spam",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "likesCount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "likedByCurrentUser",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stemLikedByCurrentUser",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewedByCurrentUser",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentedByCurrentUser",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quotedByCurrentUser",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stemLikesCount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewsCount",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentsCount",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quotesCount",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharesCount",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "VibePoll",
  "kind": "LinkedField",
  "name": "poll",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "options",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionVotesCounts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pollVotesCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votedByCurrentUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votedOptionIndex",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "condition": "includeIsAuthorized",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/)
  ]
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Vibe",
  "kind": "LinkedField",
  "name": "vibe",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v23/*: any*/),
    {
      "condition": "includeIsAuthorized",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "followingUser",
          "storageKey": null
        }
      ]
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ForMePostsListQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "includeIsAuthorized",
            "variableName": "includeIsAuthorized"
          }
        ],
        "kind": "FragmentSpread",
        "name": "forMePostsList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ForMePostsListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "VibePostConnection",
        "kind": "LinkedField",
        "name": "forMePosts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VibePostEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VibePost",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "condition": "includeIsAuthorized",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sharedByCurrentUser",
                        "storageKey": null
                      }
                    ]
                  },
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VibePost",
                    "kind": "LinkedField",
                    "name": "sharedPost",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v22/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VibePost",
                    "kind": "LinkedField",
                    "name": "quotedPost",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v22/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "ForMePostsList_forMePosts",
        "kind": "LinkedHandle",
        "name": "forMePosts"
      }
    ]
  },
  "params": {
    "cacheID": "c9ec171b0dd02341a6428ce7f85994a0",
    "id": null,
    "metadata": {},
    "name": "ForMePostsListQuery",
    "operationKind": "query",
    "text": "query ForMePostsListQuery(\n  $after: String\n  $first: Int = 8\n  $includeIsAuthorized: Boolean = false\n) {\n  ...forMePostsList_query_Pvvxi\n}\n\nfragment forMePostsList_query_Pvvxi on Query {\n  forMePosts(first: $first, after: $after) {\n    edges {\n      node {\n        id\n        message\n        media\n        created\n        removed\n        spam\n        likesCount\n        likedByCurrentUser @include(if: $includeIsAuthorized)\n        stemLikedByCurrentUser @include(if: $includeIsAuthorized)\n        viewedByCurrentUser @include(if: $includeIsAuthorized)\n        commentedByCurrentUser @include(if: $includeIsAuthorized)\n        quotedByCurrentUser @include(if: $includeIsAuthorized)\n        sharedByCurrentUser @include(if: $includeIsAuthorized)\n        stemLikesCount\n        viewsCount\n        commentsCount\n        quotesCount\n        sharesCount\n        poll {\n          id\n          options\n          optionVotesCounts\n          pollVotesCount\n          votedByCurrentUser\n          votedOptionIndex\n        }\n        sharedPost {\n          id\n          message\n          media\n          created\n          removed\n          spam\n          likesCount\n          likedByCurrentUser @include(if: $includeIsAuthorized)\n          stemLikedByCurrentUser @include(if: $includeIsAuthorized)\n          viewedByCurrentUser @include(if: $includeIsAuthorized)\n          commentedByCurrentUser @include(if: $includeIsAuthorized)\n          quotedByCurrentUser @include(if: $includeIsAuthorized)\n          stemLikesCount\n          viewsCount\n          commentsCount\n          quotesCount\n          sharesCount\n          poll {\n            id\n            options\n            optionVotesCounts\n            pollVotesCount\n            votedByCurrentUser\n            votedOptionIndex\n          }\n          author {\n            id\n            vibe {\n              username\n            }\n            followingUser @include(if: $includeIsAuthorized)\n          }\n        }\n        quotedPost {\n          id\n          message\n          media\n          created\n          removed\n          spam\n          likesCount\n          likedByCurrentUser @include(if: $includeIsAuthorized)\n          stemLikedByCurrentUser @include(if: $includeIsAuthorized)\n          viewedByCurrentUser @include(if: $includeIsAuthorized)\n          commentedByCurrentUser @include(if: $includeIsAuthorized)\n          quotedByCurrentUser @include(if: $includeIsAuthorized)\n          stemLikesCount\n          viewsCount\n          quotesCount\n          sharesCount\n          poll {\n            id\n            options\n            optionVotesCounts\n            pollVotesCount\n            votedByCurrentUser\n            votedOptionIndex\n          }\n          author {\n            id\n            vibe {\n              username\n            }\n          }\n        }\n        author {\n          id\n          vibe {\n            username\n          }\n          followingUser @include(if: $includeIsAuthorized)\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n"
  }
};
})();

node.hash = "a39d025063bf1c28d5a358347469b448";

module.exports = node;
